export default {
  cash: '現金',
  'VISA/MasterCard': 'VISA卡/萬事達卡',
  PPS: '繳費靈',
  FPS: 'FPS',
  Cheque: ' 支票',
  '7-11': '7-11',
  error: '發生錯誤，請稍後再試',
  wait: '請稍候…',
  header: {
    news: '最新消息',
    our_company: '公司概況',
    awards: '獎項',
    customer_service: '客戶服務',
    business_enquiries: '商業查詢',
    change_lang: 'ENG',
    find_carpark: '尋找車場',
    my_account: '我的專頁',
    iMONTHLY: 'i-MONTHLY ',
    login: '登入',
    logout: '登出',
    cart: '購物車',
    MobileApp: '手機程式',
    search: '網站搜尋',
    CartText: ' 你的購物車裡沒有物品',
    PageTitle: '威信停車場管理(控股)有限公司',
    CartCheckout: '結帳',
  },
  footer: {
    Home: '主頁',
    Wilson_Group: '威信集團',
    Mack_Parking: '敏記停車場',
    Wash_Wax: '威信專業汽車護理',
    Wilson_Storage: '威信儲存倉',
    FIND_CAR_PARK: '尋找車場',
    iMONTHLY_PARKER_SIGN_IN: 'i-MONTHLY月租用戶登入',
    iMONTHLY_PARKER_SIGN_OUT: 'i-MONTHLY月租用戶登出',
    Registration: '註冊',
    Cart: '購物車',
    My_Account: '我的帳戶',
    Forgot_Password: '忘記密碼',
    iMonthlyFAQ: 'i-Monthly預訂月租指南及常見問題',
    BOOK_iHOURLY: 'i-HOURLY預訂時租',
    iHourlyFAQ: 'i-Hourly預訂時租指南及常見問題',
    NEWS: '最新消息',
    OUR_COMPANY: '公司概況',
    AWARDS: '獎項',
    CUSTOMER_SERVICE: '客戶服務',
    BUSINESS_ENQUIRY: '商業查詢',
    PRIVACYPOLICY: '私隱政策',
    DISCLAIMER: '免責條款',
    Wilson_Parking: '威信停車場 (中國)',
    promobarTitle: '「繳費靈」付款服務停用',
    promobarContentTitle:
      '以「繳費靈」繳付月租的服務將於2023年1月1日起停用。請選用其他付款方式繳付月租。',
    promobarDetail1:
      '\n由11月23日起至12月5日，您可於網上申請荃灣、葵芳及天后運輸署多層停車場2023年1月至3月之泊車季票。\n\n\n申請說明書請參閱本網站之荃灣、葵芳及天后停車場網頁。',
    promobarDetail2: '按此申請泊車季票',
    promobarDetail3: '(https://www.tdcarpark.com.hk/ )',
    wilsonparking: '威信停車場(中國)',
    CopyRight: '©2018 威信停車場 版權所有',
    Office: '辦公室: 香港新界葵涌興芳路新都會廣場第1座29樓2901室/ 電話: 2830-3845',
    Email: '電郵:',
    wp: '威信停車場管理(控股)有限公司',
    licence: '物業管理公司牌照: C-544339',
  },

  Login: {
    SIGN_IN_REGISTER: '登入/註冊',
    Sign_in: 'i-MONTHLY月租用戶登入',
    Username: '用戶名稱',
    Password: '密碼',
    RememberMe: '記住帳號',
    Forgot_Password: '忘記密碼',
    Login: '登入',
    signUp: '註冊',
    Registration: '註冊',
    ParkCard: 'Park泊Card號碼',
    First_time_login: 'PARK泊CARD用戶首次登入',
    ContactNo: '聯絡電話',
    Activate: '啟動帳戶',
    CreateAc: '建立帳戶',
    NewCustomer: '新客戶？請即註冊，只需幾個步驟便能享用多項網上服務。',
    ReisterNow: '立即註冊',
    Email: '電郵地址',
    Error: '用戶名稱或密碼錯誤',
    notExist: '找不到用戶',
    signInTitle: '只需幾個步驟便能享用多項網上服務，請即註冊。',
    pleaseEnter: '如果您是月租用戶，請輸入你在停車場註冊時所填寫的手提電話號碼',
    passwordError: '輸入的密碼不正確。請重試。',
    emailError: '輸入的電郵地址無效。請重試。',
  },

  Myprofile: {
    Headertext: '建議您及時更新個人及車輛資料，以免月租服務受到影響。',
    CustomerInf: '顧客資料',
    Prefix: '稱謂',
    FirstNameEng: '名字 (英文)',
    LastNameEng: '姓氏 (英文)',
    FirstNameZh: '名字 (中文)',
    LastNameZh: '姓氏 (中文)',
    Address: '地址',
    lang: '選取語言',
    ChangePassword: '更改密碼',
    NewPassword: '新密碼',
    ConfirmPassword: '確認新密碼',
    PasswordRequest: '密碼必須最少由 8 個字母數字組成，當中必須包含一個大寫字母。',
    ChangeMobileNo: '更改手提電話號碼',
    MobileNo: '手提電話號碼',
    ReceiveSMS: '收取SMS',
    VerCode: '驗證碼',
    Verify: '驗證',
    WishPro: '我希望收到宣傳通訊，營銷電子郵件或短信。',
    WishSMS: '我希望通過SMS收到通知。',
    Reset: '重設',
    Update: '更新',
    SavedPayment: '已儲存的付款方式（信用卡）',
    NoSaved: '您沒有儲存任何付款方式',
    AddCard: '新增PARK泊CARD',
    ParkCardNo: 'Park泊Card號碼',
    PleaseSelcet: '請選擇',
    Region: '地區',
    District: '區域',
    Updated: '您的帳戶資料已更新',
    UpdatedBack: '回到上一頁',
    ActiveExpiredTitle: '逾時啟動帳戶',
    ActiveExpiredText: '請輸入您的註冊電郵以獲取新的啟動帳戶連結。',
    ActiveExpiredA: '重新發送',
    ActiveSuccessTitle: '啟動成功',
    ActiveSuccessText:
      '註冊成功！您現在可以登入網頁，輕鬆預訂、更改或終止泊車服務。您亦可更改登記的車輛登記號碼、瀏覽交易記錄及更改帳戶資料等更多服務。',
    ActiveAlreadyTitle: '您已啟動帳戶',
    ActiveAlreadyText: '請輸入用戶名稱及密碼以登入',
    PPcardError: '找不到Park泊Card號碼，請與我們的客戶服務員聯絡。',
    PasswordError: '請輸入8-15個字符的有效密碼。',
    ConfirmPasswordError: '請輸入與密碼相符的8-15個字符的有效密碼。',
    remove: '移除',
    confirmRemoveCard: '您確定要移除 {{token}}?',
    tnc: '您所提供的個人資料保存時間不會超過法律要求所需。 有關詳情，請瀏覽',
    PrivacyPolicy: '個人私隱政策聲明',
    importantText:
      '刪除帳戶後，您將無法使用預訂/續訂i-Monthly月租及其他網上服務。此外，您所有的付款及泊車記錄亦將被永久刪除。',
    confirmText:
      '重要: 移除帳戶後，您將無法使用iPark – 免觸式泊車及包括網上預訂/續訂i-Monthly月租繳款服務等所有方便快捷的服務。此外，您以往的付款及泊車記錄亦將被永久刪除。',
    confirmText1: '確定要移除您的帳戶？',
    successText: '您已成功移除您的帳戶。',
    successText1: '感謝您選用威信停車場，我們期待再次為您服務。',
    deleteAccount: '刪除帳戶',
    delete: '刪除',
    readAndAgreed: '我已閱讀及同意條款及細則。',
    tncError: '請勾選我已閱讀及同意條款及細則',
    notAvailbleChangeLPN: '該預約不能更改車輛登記號碼。',
  },

  CsList: {
    CUSTOMER_SERVICE: '客戶服務',
    BUSINESS_ENQUIRY: '商業查詢',
    Hotline: '客戶服務熱線',
    HotlineText: '我們樂於聽取客戶的意見，您可透過以下途徑聯絡我們。',
    OfficeHour: '辦公時間',
    OfficeHour1: '星期一至五 上午9:00 - 下午5:00',
    Except: '(公眾假期除外)',
    Tel: '電話',
    TelNo: '+852 2830-3845',
    EmailAddress: '電郵地址',
    LeaveMsg: '請在此留言，我們將盡快與您聯絡。',
    ContactInf: '聯絡資料',
    Email: '電子郵件',
    Name: '名字',
    ContactNo: '聯絡電話',
    CompanyName: '公司名稱',
    YourMsg: '您的訊息',
    Subject: '主旨',
    Msg: '訊息',
    Agree: '我同意個人資料收集的私隱聲明',
    Reset: '重設',
    Submit: '提交',
    Policy: '個人資料收集的私隱聲明',
    SentOutTitle: '提交成功',
    SentOutText: '感謝您的查詢，我們將盡快跟您聯絡。',
    SentOutButton: '前往主頁',
    NameError: '請輸入你的名字。',
    EmailError: '無效的郵件地址',
    PhoneError: '電話號碼無效',
    SubjectError: '請輸入主旨',
    ContentError: '請輸入訊息',
    CompanyNameError: '請輸入您的公司名稱。',
    PasswordError: '請輸入有效的登入資料',
  },

  MyAccountTap: {
    MyAccount: '我的帳戶',
    iMONTHLY: '我的服務',
    IPARK: 'IPARK無感泊車',
    PAYMENTRECORDS: '付款記錄',
    MYPROFILE: '我的用戶資料',
    Previous: '上一頁',
    Page: '第',
    Of: '，共',
    Next: '下一頁',
    Pagezh: '頁',
    nextStep: '下一步',
  },

  MyAccount: {
    WaitingList: {
      confirmed: '輪候中',
      refNo: '參考編號',
      createdAt: '加入日期',
      cancelWaiting: '取消輪候',
      addWaiting: '加入輪候名單',
      confirmCancel: '確定移除輪候中的車輛？',
      selectVehicle: '選擇加入輪候名單的車輛',
      pleaseWait:
        '當有可使用的i-Monthly服務時，我們將會與您聯絡。<br/>您可於「我的專頁」管理您的i-Monthly 輪候名單。',
      appliedSuccess: '成功加入',
      goToMyPage: '前往我的專頁',
      changeVehicleTitle: '更改加入輪候名單的車輛',
      changeVehicle: '更改車輛',
      addNewCar: '新增車輛',
      selectCar: '選擇車輛',
      haveConfirmedWaiting: '車輛已在輪候名單上',
    },
    iMonthly: {
      PleaseRead: '請細閱',
      important: '重要:',
      reminderContent: `提提您！我們的續訂服務為每月的22日至該月的最後一天，每次可續訂該月的月租服務。請緊記需於服務過期前續訂，否則服務將會被終止。`,
      AssignedCar: '指定車輛',
      ServicePeriod: '服務有效日期',
      ServiceId: '服務編號',
      ServiceStatus: '服務狀況',
      Service: '服務',
      LastPaymentDate: '最後繳費日期',
      ExpiryDate: '到期日期',
      RENEW: '續訂',
      CHANGE: '更改',
      TERMINATE: '終止',
      ChangeCar: '更改',
      successfullyTerminated: '終止預約成功',
      SomethingWrong: '終止預約失敗',
      status: {
        pending: '待確定',
        active: '有效',
        terminated: '已終止',
        expired: '已過期',
        changed: '已更改',
        renewed: '已更新',
        paid: '已付款',
        settled: '已付款',
        overpaid: '重覆付款',
        underpaid: '款項不足',
        unknown: '-',
        temporary: '短暫轉換',
        cancelled: '已取消',
        tempChangeTerminated: '已終止(短暫轉換)',
        processed: 'Processed',
      },
      confirmTerminate: '你確定要終止預約?',
      confirm: '確定',
      cancel: '返回',
      hourlyPresentReminder:
        '揀選的車牌為此停車場內的時租車輛，不可更改為月租車輛。請將車輛駛離停車場後重試。',
    },
    changeCarPark: '更改停車場/服務',
    selectNewCarPark: '請選擇新的停車場或服務',
    serviceFee: '服務金額',
    fillError: '請填寫所有資料',
    vehicleIsPresentError: '已入場車輛不能更改車輛登記號碼',
    changeMoreThanOne: '更改車輛登記號碼只限每月一次',
  },

  News: {
    Readmore: '閱讀更多',
    NEWS: '最新消息',
    N0Title: 'Wetland Public Vehicle Park',
    N0Text: '天水圍Wetland Public Vehicle Park於2022年7月1日開業',
    N1Title: '讀者文摘信譽品牌白金獎',
    N1Text: '我們欣然宣佈，我們連續十年榮獲「讀者文摘信譽品牌白金獎」殊榮。',
    N3Title: '金鐘停車場電動車充電區',
    N3Text: '可享高達4小時免費充電*！',
    N4Title: '申請運輸署停車場泊車季票',
    N4Text: '您可於網上申請運輸署停車場之泊車季票',
    N5Title: '威信停車場手機應用程式',
    N5Text: '下載威信停車場手機應用程式，開啟智能泊車新體驗',
    N6Title: '荃灣達貿中心開業',
    N6Text: '荃灣達貿中心於2022年7月1日開業',
    N7Title: '沙田好運中心開業',
    N7Text: '沙田好運中心於2022年7月1日開業',
    N8Title: '大埔超級城多層停車場開業',
    N8Text: '大埔超級城多層停車場於2022年8月1日開業',
    N9Title: '土瓜灣旭日街重開',
    N9Text: '土瓜灣旭日街於2022年9月1日重開',
    N10Title: '送車廂臭氧消毒服務3次',
    N10Text: '登記SmarTone Home 5G 寬頻獨家優惠',
    N11Title: '金鐘停車場電動車充電區',
    N11Text: '快速充電每小時只需$30。快啲嚟體驗吓啦！',
    N12Title: '西九文化區停車場開業',
    N12Text: '西九文化區停車場於2022年12月15日開業',
    N13Title: '2023年1月新場開業',
    N13Text: '於2023年1月1日開業之停車場',
    N1Detailtext1: '我們欣然宣佈，我們連續十年榮獲「讀者文摘信譽品牌白金獎」殊榮。',
    N3Detailtext1:
      '<p>推廣期內，所有電動車車主於金鐘停車場，均可享高達4小時免費充電*：</p><ul><li><p>快速充電首2小時免費</p></li></ul><ul><li><p>中速充電首4小時免費</p></li></ul><p><a style="color:black;font-weight:bolder;" href="https://www2.wilsonparking.com.hk/edm/202207/eDM_202207.html">按此</a>了解更多&nbsp;</p><p>*須繳付時租泊車費用。</p>',
    N4Detailtext1:
      '<p>您可於網上申請運輸署停車場之泊車季票</p><div><a>葵芳停車場</a></div><div><a>荃灣停車場</a></div><div><a>天后停車場</a></div><div style="margin-top:40px"><a href="https://www.tdcarpark.com.hk/" target="_blank" style="color:black;font-size:0.875rem;font-weight:bolder;">> 按此申請泊車季票</a></div>',
  },

  Our_company: {
    Our_company: '公司概況',
    HeaderText:
      '威信停車場是一家世界級的停車場管理及顧問公司，擁有超過四十五年的管理經驗。香港特別行政區威信停車場及其他國內主要城市的威信停車場同為香港新鴻基地產發展有限公司擁有的全資附屬公司。',
    ESTABLISHED: '成立於',
    MANAGE: '管理',
    BAYS: '車位',
    OPERATE: '經營',
    CARS_PARKS: '停車場',
    VISION: '抱負',
    VISION_text:
      '我們矢志成為一家世界級的，與運輸設施相關的服務行業機構，本著熱誠及專業精神，滿足客戶需要。',
    MISSION: '使命',
    MISSION_text: '我們將以優質、具創意的產品和服務，提高效率，令服務更安全更可靠。',
    VALUES: '信念',
    VALUES_text: '我們的信念包括：以客為尊，創新與科技，卓越服務，團隊精神及精益求精。',
    QUALITY_ASSURANCE: '品質保證',
    h1: '威信停車場一直致力為客戶提供具國際水準、創新、安全及可靠的停車場管理服務',
    h2: '威信於20年前率先取得ISO9002品質管理體系，成為香港首間獲認證的停車場管理公司。在奠定重要里程碑的同時，威信繼續務實地優化品質管理體系。',
    h3: '時至今日，威信在四個主要範疇中均已取得國際認證，包括品質管理體系ISO 9001:2015、環境管理體系ISO 14001: 2015、顧客滿意度管理體系ISO 10002:2014，以及職業健康和安全管理體系OHSAS 18001: 2007。',
    h4: '我們的綜合管理體系均備存清晰記錄，由前線人員組成的管理委員會會定期檢視停車場之運作，確保所有員工都能切實理解及執行每個體系及程序的要求。',
    h5: '此外，自2010年起，威信停車場榮獲「Q 嘜」優質服務計劃認證。「Q 嘜」為遵守國際公認標準來提高服務及管理質素的一項舉措，透過定期監督和現場審計，宣揚本地和海外優質服務的理念。',
  },

  iHourlyFAQ: {
    Header: 'i-HOURLY 預訂時租指南及常見問題',
    aaa: '<1>Hello</1> <3>name</3>',
    h1Q: '甚麼是 i-HOURLY？',
    h1T: '通過我們的網上預訂系統輕鬆預訂時租車位，不需再在停車場入口排隊苦候！',
    h2Q: '怎樣使用 i-HOURLY？',
    h2A1: '1. 進入您想預訂 i-Hourly 服務的停車場資訊頁面。按時租收費旁的「預訂」按鈕。',
    h2A2: '2. 選擇泊車日期及時間，再輸入您的基本資料。',
    h2A3: '3. 以「Visa」/「萬事達咭」/「繳費靈」繳付手續費。預訂確認通知將以電郵/SMS傳送給您。',
    h2A4: '4. 於預訂時間到達所選停車場*。我們的職員會於您到達停車場時提供協助。',
    h2T1: '* 時租收費會於進入停車場時開始計算。',
    h2T2: '如於到達前有任何疑問，可於星期一至五辦公時間內致電 2830-3845 或電郵至',
    h2T3: '與我們的 i-Hourly 團隊聯絡。',
    FAQ: 'i-HOURLY 常見問題 ',
    Q1: '1. 預訂了但最後沒有泊車，可以退款嗎？',
    A1: '很抱歉，手續費不設退還。',
    Q2: '2. 為甚麼找不到某些停車場或時段呢？',
    A2: '現階段，i-Hourly預訂服務只適用於特定停車場。如您找不到想要的空缺，請嘗試其他停車場或時段。',
    Q3: '3. 為甚麼要收取手續費？',
    A3: '手續費確保您能在預訂日期及時間取得車位。',
    Q4: '4. 可以取消或更改我的預訂嗎？應該怎樣做？',
    A4: '預訂一經確認，不能取消。您可以在24小時前電郵至 ',
    A41: '更改預訂。更改視乎車位供應而定。',
    Q5: '5. 怎樣知道預訂是否成功？',
    A5: '成功付款後，預訂確認會通過電子郵件/短信傳送給您。',
    Q6: '6. 到達停車場時應該怎樣做？',
    A6: '由於停車場各有不同的運作，請留意詳列於預訂確認之指示。當到達停車場時，我們的職員會樂意協助您。',
    Q7: '7. 如遲了到達停車場，會怎麼樣？',
    A7: '我們會根據你的預訂時間為您預留車位一小時，不設補時。',
    Q8: '8. 最早能幾時預訂車位？',
    A8: '最早可於14天前預訂。',
    Q9: '9. 最遲可以幾時預訂車位？',
    A9: '最少必須於24小時前預訂。',
    Q10: '10. 遇到有關預訂的疑問，可以跟誰聯絡？',
    A10: '如於到達前有任何疑問，可於星期一至五辦公時間內致電 2830-3845 或電郵至',
    A101: '與我們的 i-Hourly 團隊聯絡。',
  },

  iMonthlyFAQ: {
    Header: 'i-MONTHLY預訂月租指南及常見問題',
    HeaderText: '享受 i-Monthly 網上預訂月租服務，',
    HeaderText1: '需註冊成為 i-Monthly 月租用戶。',
    HeaderText2: '若尚未成為 i-Monthly 月租用戶，請即',
    HeaderText2zh: '註冊。',
    HeaderText2en: '',

    Title1: 'i-MONTHLY 預訂月租指南',
    T1Q1: '甚麼是 i-Monthly 預訂月租？怎樣使用？',
    T1A1: '成為 i-Monthly 月租用戶，便可在威信網站以幾個簡單步驟預訂及管理各項月租服務。',
    T1A1a: '不論是預訂、續訂月租服務、更改車輛登記號碼還是更新個人資料，我們都全天候為您服務。',

    T1Q2: '怎樣預訂新月租服務？',
    T1Q2A1: '1. 登入',
    T1Q2A11: '「i-Monthly月租用戶」。',
    T1Q2A2: '2. 到',
    T1Q2A21: '「尋找車場」',
    T1Q2A22: '選取合適的停車場。',
    T1Q2A3: '3. 選取月租服務，然後按',
    T1Q2A31: '「預訂」。',
    T1Q2A4: '4. 於',
    T1Q2A41: '「購物車」',
    T1Q2A42: '確認詳情及選擇領取',
    T1Q2A43: '「Park泊Card」',
    T1Q2A44: '方法。',
    T1Q2A5: '5. 按步驟付款，交易成功後，預訂確認通知將通過電子郵件/短訊傳送給您。 ',

    T1Q3: '怎樣續訂月租服務？',
    T1Q3A1: '1. 登入',
    T1Q3A11: '「i-Monthly月租用戶」。',
    T1Q3A2: '2. 從',
    T1Q3A21: '「我的帳戶」',
    T1Q3A22: '選取',
    T1Q3A23: '「服務記錄」。',
    T1Q3A3: '3. 檢視現有月租服務。',
    T1Q3A4: '4. 按',
    T1Q3A41: '「續訂」',
    T1Q3A42: '。所選的服務將添加至',
    T1Q3A43: '「購物車」。',
    T1Q3A5: '5. 於',
    T1Q3A51: '「購物車」',
    T1Q3A52: '確認詳情後付款。交易成功後，續訂確認通知將通過電子郵件/短訊傳送給您。',

    T1Q4: '怎樣更新我的個人資料？ ',
    T1Q4A1: '1. 登入',
    T1Q4A11: '「i-Monthly月租用戶」。',
    T1Q4A2: '2. 從',
    T1Q4A21: '「我的帳戶」',
    T1Q4A22: '選取',
    T1Q4A23: '「帳戶資料」。',
    T1Q4A3: '3. 更新所需資料。按',
    T1Q4A31: '「更新」。',
    T1Q4A32: '',

    T1Q5: '怎樣更改車輛登記號碼？ ',
    T1Q5A1: '1. 登入',
    T1Q5A11: '「i-Monthly月租用戶」。',
    T1Q5A2: '2. 從',
    T1Q5A21: '「我的帳戶」',
    T1Q5A22: '選取',
    T1Q5A23: '「服務記錄」。',
    T1Q5A3: '3. 選取月租服務。',
    T1Q5A4: '4. 按',
    T1Q5A41: '「指定車輛」',
    T1Q5A42: '然後選取',
    T1Q5A43: '「更改」。',
    T1Q5A5: '5. 您可以選擇',
    T1Q5A51: '暫時更改',
    T1Q5A52: ' (使用期限為五天，無需額外行政費) 或',
    T1Q5A53: '永久更改',
    T1Q5A54: '車輛登記號碼 *(我們將收取行政費港幣50元正)。',
    T1Q5A6: '6. 輸入新的車輛登記號碼及開始日期 (只適用於永久更改)。按',
    T1Q5A61: '「確認」。',
    T1Q5A7: '7. 檢視已更改的內容，如需繳交行政費，請按步驟付款',
    T1Q5A8: '8. 更改確認通知將通過電子郵件/短訊傳送給您 (只適用於永久更改)。',
    T1Q5strt:
      '*於續訂月租服務時，永久更改車輛登記號碼，可獲豁免行政費。更新的車輛登記號碼將由所續訂服務期的第一天起生效。',

    T1Q6: '怎樣更改月租服務？',
    T1Q6Text:
      '您可以更改現有的月租服務 (例如選取不同之停車場或其他月租服務)，更改將由續訂服務期的第一天起生效。',
    T1Q6A1: '1. 登入',
    T1Q6A11: '「i-Monthly月租用戶」。',
    T1Q6A2: '2. 從',
    T1Q6A21: '「我的帳戶」',
    T1Q6A22: '選取',
    T1Q6A23: '「服務記錄」。',
    T1Q6A3: '3. 選取月租服務。',
    T1Q6A4: '4. 按',
    T1Q6A41: '「更改」',
    T1Q6A42: '。您可按需要選取停車場及月租服務。',
    T1Q6A5: '5. 於',
    T1Q6A51: '「購物車」',
    T1Q6A52: '確認詳情，然後付款。',

    Title2: 'i-MONTHLY 預訂月租常見問題',
    T2Q1: '1. 為甚麼找不到某些停車場的月租服務呢？',
    T2A1: '現階段，i-Monthly 預訂服務適用於特定停車場。如所尋找的停車場並未提供所需服務，請嘗試其他停車場。',
    T2Q2: '2. 預訂了但最後沒有使用月租服務，可以退還月租費嗎？',
    T2A2: '很抱歉，月租費不獲退還。',
    T2Q3: '3. 怎樣更改車輛登記號碼？',
    T2A3: '您只需登入 i-Monthly 月租帳戶，可更改車輛登記號碼。詳情請按 ',
    T2A31: '',
    T2A32: '',
    T2A3x: '這裡。',
    T2Q4: '4. 怎樣更改聯絡資料？',
    T2A4: '您可從「我的帳戶」中選取「帳戶資料」以更改聯絡資料。 ',
    T2Q5: '5. 怎樣查閱預訂記錄？',
    T2A5: '您可從「我的帳戶」中選取「服務記錄」以查閱預訂記錄。',
    T2Q6: '6. 怎樣才能確認預訂是否成功？',
    T2A6: '預訂成功後，您將以電子郵件/短訊收到預訂確認通知。',
    T2Q7: '7. 如果忘記續訂會怎樣？',
    T2A7: '如於月租服務過期前沒有辦理續訂，服務將會自動終止。',
    T2Q8: '8. 最早可以何時選擇及預訂月租服務？',
    T2A8: '您可於每月22號起預訂下一個月份的月租服務。 ',
    T2Q9: '9. 預訂如遇疑問，可以怎樣？',
    T2A9: '您可於星期一至五辦公時間內致電 2830-3845 或電郵至 ',
    T2A91: '與 i-Monthly 團隊聯絡。 ',
    T2Q10: '10. 遺失「Park泊Card」怎麼辦？',
    T2A10:
      '如遺失「Park泊Card」，請立即通知我們。您可以申請重發「Park泊Card」，行政費為港幤200元正。',
    T2Q11: '11. 可以利用「Park泊Card」進入其他非預訂的停車場嗎？',
    T2A11: '您只能用「Park泊Card」進入已預訂月租服務的停車場。',
    T2Q12: '12. 忘記帳戶名稱/密碼怎麼辦？',
    T2A12:
      '「用戶名稱」為您登記的電郵地址。如需重設密碼，可於「登入/註冊」點擊「忘記密碼」，然後按指示重設密碼。',
    T2Q13: '13. 怎樣將目前的月租服務轉至其他停車場？',
    T2A13: '您可於每月22號至該月最後一日更改停車場，更改之服務將由下月的第一天生效。詳情請按 ',
    T2A131: '這裡。',
    Title3: '需要協助？',
    T3Text: '您可於星期一至五 (公眾假期除外) 辦公時間內致電 2830-3845 或電郵至 ',
    T3Text1: '與 i-Monthly 團隊聯絡。',
  },

  ForgotPassword: {
    Header: '忘記密碼',
    ResetByEmail: '通過電子郵件重設密碼',
    Text: '請輸入已註冊的電郵地址，獲取連結重設密碼',
    Email: '電郵地址',
    Submit: '提交',
    Or: '或',
    ResetByMob: '通過手提電話號碼重設密碼',
    Step1: '請輸入已登記的手提電話號碼，獲取重設密碼驗證碼。',
    Step2: '重設密碼的驗證碼將於120秒後失效。您可按「重新傳送」，再次以SMS取得重設密碼。',
    MobileNo: '手提電話號碼',
    ResetPasswordCode: '重設密碼的驗證碼',
    ReceiveSMS: '收取SMS',
    Verify: '驗證',
    ReSend: '重發SMS',
    ErrorEmail: '電郵地址錯誤',
    Error: '錯誤碼：401，請稍後再嘗試',
    Error403: '錯誤碼：403，請稍後再嘗試',
    notExistPhone: '找不到用戶',
  },

  ResetPassword: {
    Title: '重設密碼',
    Password: '新密碼',
    ComPassword: '確認新密碼',
    Reset: '重設',
    Submit: '傳送',
    ByEmailTitle: '繼續重設密碼',
    ByEmailText: '重設密碼的連結已傳送至您登記的電郵地址，請按指示重設密碼。',
    ByEmailButton: '回到「登入」頁',
    ResetedTitle: '您的密碼已更新',
    ResetedButton: '回到登入',
    PasswordError: '您的密碼必須在8至15個字元之間，包含最少一個大寫字母及一個數字。',
    ConfirmPasswordError: '請輸入與密碼相符的有效密碼',
  },

  Registration: {
    Header: '首次註冊',
    Required: '必填項目',

    Title1: '註冊資料',
    EmailPlaceholder: '用作用戶名稱',
    Email: '電郵地址',
    ComEmail: '確認電郵地址',
    Password: '密碼',
    ComPassword: '確認密碼',
    PasswordRequest: '密碼必須至少由 8 個字母數字組成，當中必須包含一個大寫字母。',

    Title2: '顧客資料',
    Prefix: '稱謂',
    FirstNameEng: '名字 (英文)',
    LastNameEng: '姓氏 (英文)',
    FirstNameZh: '名字 (中文)',
    LastNameZh: '姓氏 (中文)',
    Address: '地址',
    PreferredLanguage: '選取語言',
    Region: '地區',
    District: '區域',

    Title3: '車輛資料',
    Type: '類型',
    PleaseSelect: '請選擇',
    VehicleRegistrationMark: '車輛登記號碼',

    Title4: '手提電話號碼',
    Note: '我們需要您的手提電話號碼以完成註冊。如遇緊急狀況，我們將致電聯絡。',
    Mobile: '手提電話號碼',
    VerificationCode: '驗證碼',
    ReceiveSMS: '收取SMS',
    Verify: '驗證',
    Iagree: '我同意',
    AgreeTerm: 'i-Monthly月租服務的條款',
    AgreePrivacy: '個人資料收集的私隱聲明',
    WishPro: '我希望收到宣傳通訊，營銷電子郵件或短信。',
    WishSMS: '我希望通過SMS收到通知。',
    Reset: '重設',
    Register: '註冊',

    EmailExistError: '電郵地址已被使用，請嘗試另一個或登入。',
    PhoneExistError: '手機號碼已被使用，請嘗試另一個或登入。',
    EmailError: '電郵地址無效。',
    EmailEnterError: '請輸入您的電子郵件地址',
    ConfirmEmailError: '無效的確認電子郵件地址。',
    ConfirmEmailEnterError: '請輸入您的確認電子郵件地址',
    PasswordError: '請輸入8-15個字符的有效密碼。',
    ConfirmPasswordError: '請輸入與密碼相符的8-15個字符的有效密碼。',
    prefixError: '請選擇一個稱謂。',
    firstNameError: '請輸入您的名字。',
    lastNameError: '請輸入您的姓氏。',
    languageError: '請選擇語言。',
    phoneError: '手機號碼無效。',
    phoneEnterError: '請輸入您的手機號碼',
    VerificationCodeError: '請輸入您的驗證碼',
    UsedEmailError: '電郵地址已被使用，請嘗試另一個。',
    TryLater: '請稍後再試一次。',
    registrationMarkError: '無效的車輛登記號碼。',

    registeredTitle: '感謝選用威信',
    registeredText:
      '你的帳戶還未啟動。你會收到一個附有啟動連結的電郵，請於兩小時內按啟動連結以完成啟動程序。',
    registeredButton: '進入「我的帳戶」',
  },

  Disclaimer: {
    Title: '免責條款',
    Text1:
      '本網站設立之目的是要介紹威信停車場管理(控股)有限公司 (簡稱「本公司」)的資料及其提供之服務以作參考用途。',
    Text2:
      '本網站所提供的資料是以"現況"及"現有"的基礎提供，不包含任何明示或暗示的保證、擔保和陳述。在香港特別行政區法律容許的範圍內，本公司拒絕承認所有明示及暗示的保證及陳述，包括但不限於就任何具體目的的可銷售性、保用性或適合性作出的任何暗示保證或隱含條款，儘管本公司已盡力確保有關資料的準確性。本公司並不對任何經由本網站所連結至網際網路其他網頁/站及其任何內容的現有性、準確性、完整性或可靠性等作認可。',
    Text3:
      '本公司可以隨時在不給予通知的情況下修改本網站的資料，而且不會保證資料的完整性、可靠性和準確性。 如閣下在使用或因無法使用本網站內的資料時、或者經本網站連結到互聯網上接觸到其他材料，因而造成本身有任何直接、間接或相應損失，閣下同意本公司不會承擔任何法律責任 (合同、侵權或其他)。',
    Text4: '上述免責條款及限制適用於香港特別行政區法律所容許的最大程度內。',
    Text5: '英文及中文文本假如出現不一致，以英文文本為準。',
  },

  PrefixData: {
    Mr: '先生',
    Ms: '女士',
    Mrs: '太太',
  },

  Title: {
    Title: '威信停車場管理（控股）有限公司',
  },

  TabContainer: {
    iMONTHLY: '我的服務',
    IPARK: 'IPARK無感泊車',
    PAYMENT_RECORDS: '付款記錄',
    MY_PROFILE: '我的用戶資料',
    waitingList: 'I-MONTHLY輪候名單',
  },

  Home: {
    promoimg1title: '隨時．隨地．合泊',
    promoimg1text:
      '威信為香港駕駛人士服務超過30年，富經驗的團隊專業而親切，結合創新科技，以客為先，竭誠服務。',
    promoimg2title: '泊車「智」SMART',
    promoimg2text:
      '全新手機程式提供即時車位數目，i-Monthly助您預訂<br/>及繳交月租，輕鬆化身泊車達人！立即下載！',
    promoimg3title: '港珠澳大橋停車場',
    promoimg3text: '網上預約日租HK$160起！您可於入場前4小時進行預約車位！<br/>立即預約 > > > ',
    promoimg4title: '充滿「正」能量！',
    promoimg4text: '電動車充電網絡遍港九，<br/>最強配套，每日為您提供潔淨「正」能量！',
    searchbyregion: '地區搜尋',
    searchbyaddress: '地址搜尋',
    searchholder: '輸入地址...',
    layer1Title: '轉數快 - 一掃即付 I-MONTHLY 月租',
    layer1subTitle: '如何付款',
    layer1text1: '1. 選擇轉數快後，',
    layer1text2: '【電腦用戶】一個二維碼會顯示在螢幕上。',
    layer1text3: '【手機用戶】請用螢幕截圖儲存二維碼。',
    layer1text4: '2. 用手機開啟閣下指定銀行之應用程式。',
    layer1text5: '  選擇「轉數快付款」，並登入銀行帳戶。',
    layer1text6: '【電腦用戶】用手機掃瞄螢幕上的二維碼即可付款。',
    layer1text7: '【手機用戶】上載已儲存的二維碼後即可付款。',
    layer2Title: '網上預訂',
    layer2Title1: '讓泊車更容易',
    layer2sub1: 'i-Monthly預訂月租',
    layer2text1: '現在您可隨時隨地、輕而易舉地尋找及預訂月租服務。只需開設i-Monthly帳戶，',
    layer2text11: '就能輕易地續訂及管理各項月租服務。',
    layer2href1: '立即註冊',
    layer2href2: '了解更多',
    layer2sub2: 'i-Hourly預訂時租',
    layer2text2: '有無諗過只需Click幾下，就能在下個會議、午餐或約會目的地預訂車位?',
    layer2text22: '從此不用再為尋找車位而奔波，節省寶貴時間，讓您 專注拼搏、盡情娛樂。',
    layer2href3: '立即預訂時租車位',
    layer2href4: '了解更多',

    RegionSelector: '選擇地區',
    DistrictSelector: '選擇區域',
  },

  MobileApp: {
    Title: '威信停車場手機應用程式',
    text1: '下載',
    text11: '全新',
    text12: '威信停車場手機應用程式，開啟智能泊車新體驗！',
    text2:
      '威信停車場手機程式操作簡易，能讓您輕鬆查閱各區威信停車場之實時泊車資訊，貼心實用，彈指間輕易掌握鄰近車場之尚餘車位數目及泊車收費，簡單一按即可導航至點選之車場入口。現在您可透過',
    text22: '「i-Monthly預訂月租」',
    text23: ' 隨時隨地輕鬆繳交月租，體驗方便快捷的繳費服務。',
    text24: '「美食消閒」',
    text25: '提供停車場附近的熱門餐廳及不能錯過的活動資訊。',
    text26: '「Park+泊賞」',
    text27: '更為您搜羅了一系列泊車相關之著數獎賞，驚喜源源不絕。 ',
    subtext: '重點功能：',
    text3: '停車場',
    text33:
      '停獲取即時泊車資訊 — 尚餘車位數目、鄰近車場位置、停車場詳盡資料、泊車選項、車輛類別及收費、一按導航至停車場入口',
    text4: '美食消閒:',
    text44: ' 網羅附近餐廳及有趣活動資訊',
    text5: 'i-Monthly 預訂月租：',
    text55: '隨時隨地即可預訂及續訂月租泊車服務',
    text6: '我的專頁：',
    text66: '管理月租服務、查閱付款記錄、更新車輛登記號碼等',
    text7: 'Park+泊賞',
    text77: '即時訂購獨家汽車美容及泊車相關著數獎賞',
  },

  PRIVACYPOLICY: {
    Header: '私隱政策',
    Title1: '< 私隱政策聲明 >',
    T1text1:
      '以下是威信停車場管理(控股)有限公司、其附屬公司與聯營公司(以下簡稱「本公司」)根據《個人資料(私隱)條例》(第486章)之規定所訂之私隱政策聲明。我們將確保我們之職員將執行有關政策，嚴格保密你的個人資料。',
    T1text2:
      '本公司保障客戶及本網站用戶所提供之一切資料。除於會籍申請、會籍續期、會籍/戶口維護、登記電郵地址、網上支付本公司的產品、使用汽車地理位置導航服務、及提供/收集網上意見服務時，我們可能需要收集其個人資料及記錄用戶電腦的網路位址外，我們不會於用戶瀏覽網站時收集任何足以識別個人身份之資料。當用戶瀏覽網站時，我們僅將其瀏覽記錄為一次按動次數，而不收集任何個人資料。而此等資料將用於編備有關我們網站使用情況之一般統計資料。',

    Title2: '使用Cookies檔案',
    T2text1:
      '我們在網站上使用cookies以提高網站的性能和增強閣下的在線體驗。 我們使用Session cookies令閣下可瀏覽及使用網站上的基本功能，例如保留登入資料並減少在互聯網上資料傳遞的需要。我們使用Google Analytics識別重訪用戶以使我們能夠更好地了解用戶如何瀏覽我們的網站及瀏覽網站所花的時間和頻率，從而改善我們的網站。閣下瀏覽我們的網站時，我們使用 Font size cookies來提供適當的字符外觀。我們在使用cookies時，將不會向閣下收集任何個人資料。',
    T2text2:
      '任何個人資料的收集將按本公司的《個人資料收集聲明》的條款所進行。個人資料將會安全穩妥儲存於我們的系統內，而本公司將採取所有切實可行的步驟，以確保個人資料的保存時間不超過將其保存以貫徹該資料被使用於或會被使用於的目的(包括任何直接有關的目的)所需的時間。只有經培訓及獲授權的職員才可獲准查閱該等個人資料，除《個人資料收集聲明》所載之人士除外，我們不會向任何本公司以外的人士發佈該等個人資料，用戶有權根據載於《個人資料收集聲明》的程序，要求存取及更正其個人資料。',
    T2text3:
      '本公司可不時根據用戶之個人資料向他們寄出宣傳產品及服務之直接市場推廣訊息。在直接市場推廣過程中，我們將提供適當之「拒絕服務選擇」。',
    T2text4:
      '本公司將竭盡所能，確保用戶之私隱獲得妥善保障。然而，鑑於互聯網之性質，我們不能擔保可以做到「完全保障」。',
    T2text5:
      '本公司會起用第三者內容供應商及服務供應商，並提供接駁其他網站之連結。此等第三者可於用戶使用其服務時收集有關用戶之個人資料。此等第三者將依其私隱政策行事，而我們的《私隱政策聲明》及《個人資料收集聲明》並不涵蓋該等第三者。',
    T2text6:
      '用戶如對我們之私隱政策及慣例有任何疑問，請電郵 info@wilsonparking.com.hk 往威信停車場管理(控股)有限公司，或投寄到新界葵涌興芳路新都會廣場第一座2901室收。',

    Title3: '< 個人資料收集聲明 >',
    T3text1:
      '本聲明乃遵照《個人資料(私穩)條例》(第486章)的要求而發出，通知閣下收集資料的目的、閣下同意我們如何使用這些資料和及閣下的權利。本聲明會不時更改，故請定期查閱。閣下登記使用我們之服務及每次登入我們網站，即表示同意接受當時生效之個人資料收集聲明。',

    Title4: '資料之收集',
    T4text1:
      '在使用我們網站之時，閣下可能會被要求向我們提供個人識別資料，例如姓名、電話號碼、電郵地址及信用咭資料等。為向閣下提供本網站之各項服務及活動，該些資料是必要的。倘若閣下未能提供所需資料，我們將不能向閣下提供我們網站上可供享用之服務及活動。',
    T4text2: '我們可能記錄訪問本網站所使用的電腦的網路位址。',

    Title5: '資料之目的及用途',
    T5text1: '我們所收集之資料將用作以下用途：',
    T5text2: '- 監控本網站之運作及協助本網站之未來發展',
    T5text3: '- 匯編有關我們之用戶之整體統計資料以作關於網站使用的分析',
    T5text4: '- 為有意註冊本網站上所提供的服務的用戶設立戶口及維護其戶口',
    T5text5: '- 為有意申請入會的用戶註冊會籍及維護其會籍',
    T5text6: '- 識別和核實使用本網站所提供服務的用戶的身份',
    T5text7: '- 就有關或因使用本網站上所提供的服務發生的事項與用戶溝通',
    T5text8: '- 為本公司進行研究及/或分析',
    T5text9:
      '- 不時向用戶提供關於本公司的資訊，包括本公司為用戶提供的產品、設施、服務及其他優惠、奬賞及其他得益的資訊',
    T5text10: '- 對查詢、建議、投訴及索償的處理及跟進',
    T5text11: '- 為更瞭解客戶的需要而進行服務抽樣調查',
    T5text12: '- 改善產品及服務以迎合客戶及/或完善向客戶所發出的資料',
    T5text13:
      '我們有意使用閣下的姓名、聯繫資料和任何與可能感興趣的商品和服務有關的資料，提供閣下可能有興趣的資訊，包括有針對性的橫幅廣告、新服務和產品和其他優惠並進行直接促銷，包括產品、服務、諮詢、意見和與停車場服務有關的促銷標的。我們還有意而閣下亦同意，為上述目的轉移和提供上述資料予在香港以內和以外我們的母公司、附屬公司、聯營公司或關聯公司、或本公司控制或共同控制的公司、和協助本公司為閣下提供各項產品、設施、服務及其他其他優惠、獎賞或其他得益的供應商。如無閣下的同意，我們則不能如上使用或向該些機構提供上述資料。閣下可在向我們網站提供資料時表示同意，或以書面向我們表示同意，不另收費。',

    Title6: '資料之轉移',
    T6text1:
      '除了為上述目的使用有關資料時，合理而有需要把有關資料轉移予的相關人仕及機構外，我們不會以可識別閣下之方式向任何其他人士披露或傳遞閣下之資料。',

    Title7: '使用Cookies檔案',
    T7text1:
      '我們在網站上使用cookies以提高和增強閣下的在線體驗。 我們使用Session cookies令閣下可瀏覽及使用網站上的基本功能，如保留登入資料可減少在互聯網上資料傳遞的需要。我們使用Google Analytics於識別重訪用戶瀏覽我們的網站，以使我們能夠更好地了解用戶如何瀏覽並通過我們的網站，所花的時間和頻率，從而可改進我們的網站。當閣下瀏覽我們的網站時，我們使用 Font size cookies來提供適當的字符外觀。我們在使用cookies時，將不會向閣下收集任何個人資料。',

    Title8: '資料之查閱',
    T8text1:
      '閣下有權根據《個人資料（私隱）條例》(第486章)的規定，要求查閱或更正閣下之個人資料。如有任何查閱或更正資料的要求，請電郵 info@wilsonparking.com.hk 或投寄到新界葵涌興芳路新都會廣場第一座2901室收。',
    T8text2:
      '本公司感謝貴客戶長期支持，我們不時與貴客戶分享本公司的各種最新資訊。如貴客戶不願意收取本公司的直接促銷材料及/或資訊，可以向我們發出書面通知寄：新界葵涌興芳路新都會廣場第一座2901室收或電郵至：info@wilsonparking.com.hk。',

    Title9: '< 資料保密政策 >',
    T9text1:
      '保護您資訊的安全對我們非常重要。 我們使用傳輸層安全（TLS）高級技術來加密客戶的私人資訊，以便在資訊通過互聯網傳輸時不會被讀取。 由於“HTTPS”會顯示在我們的網址中，因此可以通過按一下流覽器欄上的鎖定符號來查看安全證書的詳細資訊。客戶於網上繳費時將被轉至第三機構付款平台進行VISA咭，萬事達咭和繳費靈的安全支付程序，本公司沒有及亦不會保存客戶提供予第三機構的相關付款資料。',
    T9text2: '中文譯本，如有任何爭議，一切以英文為準。',
  },

  iMONTHLYTerms: {
    Title: '< 有關訂購及使用月租泊車服務之條款及細則 >',
    Text1:
      '新購或續購月租泊車服務的客戶須接受及遵守張貼於威信停車場管理(控股)有限公司(以下簡稱“本公司”) 停車場入口的“泊車及使用條款”，或張貼於本公司網站(“www.wilsonparking.com.hk”)、手機應用程式及停車場內之其他條件及細則。否則本公司有權終止其月租泊車服務並且不會作出任何賠償。',
    Text2: '1. 訂購月租泊車服務',
    Text3:
      '新月租客戶訂購月租泊車服務時要視乎車位供應情況，客戶可透過本公司網站或手機應用程式登入/註冊為月租客戶及使用指定的電子支付模式或其他方式(如適用)繳付首月費用。',
    Text4:
      '訂購月租泊車服務的首月費用：當月15號或之前訂購，須繳付整月的月租泊車服務費用；當月16號至21號訂購，須繳付半個月的月租泊車服務費用；當月22號至月底訂購，須同時繳付半個月的月租泊車服務費用及下一個月整月的月租泊車服務費用。',
    Text5:
      '客戶於本公司網站或手機應用程式預訂新月租泊車服務的過程中，所選月租泊車服務將預留15分鐘以便於此時段內完成預訂程序，當客戶於預訂程序中途取消預訂或過程超越15分鐘，所選之預訂月租泊車服務將被取消。客戶於網上繳費時將被轉至第三方機構付款平台進行安全支付程序，包括但不限於VISA咭、萬事達咭、快速支付系統（轉數快）和繳費靈，需要遵守相關的條款，本公司不承擔該支付服務所引致的任何責任。本公司沒有及亦不會保存客戶提供予第三方機構的相關付款資料。',
    Text6: '一個車牌號碼於同一停車場，只可訂購一項月租泊車服務。',
    Text7:
      '現有客戶可透過本公司網站或手機應用程式內的「我的帳戶」管理個人資料及可於每月二十二日至月底期間使用指定的電子支付模式續購下月份之月租泊車服務。閣下所提供的個人及其他有關資料會用於處理日常之月租泊車服務。若客戶未能提供或沒有提供足夠或正確的資料有可能會影響本公司向閣下於本公司網站或手機應用程式上列明之服務。客戶可於閣下的帳戶內查閱或修改個人及其他資料。及時更新個人及其他資料十分重要，可確保閣下的月租泊車服務不會受到不必要的中斷。',
    Text8:
      '凡欲於7-11便利店以現金或匯豐銀行「入票易」機以支票(劃線支票抬頭請填寫<威信停車場管理(控股)有限公司>)繳付月租泊車服務費用，必須於月租到期前最少三個工作天繳付。',
    Text9:
      '如月租泊車服務於到期前仍沒有辦理續購，月租泊車服務將會自動終止，而該月租泊車服務的配額將會分發給其他客戶。客戶在月租泊車服務到期後欲再訂購，將被當作新月租客戶訂購月租泊車服務，並視乎當時的月租泊車服務供應而定。凡未有續購仍逾期停留於停車場內之車輛將由到期日後起按時租收費。',
    Text10: '月租泊車服務費用一經繳付，不論有否使用服務均不獲退款。',
    Text11:
      '客戶只可駕駛已經登記的車輛及持有效之月票、智能咭、遙控器或使用免觸式泊車系統或其他指定方式進出停車場。',

    T2Title: '2. 月租泊車服務之有效期限',
    T2Text:
      '月租泊車服務將於所訂購/續購的月租泊車服務期限內有效。整月月租泊車服務之有效期為每月首日之零時零分起至每月最後一日之晚上十一時五十九分為止。',
    T3Title: '3. 使用月租泊車服務 (適用於設有自動閘機系統的停車場)',
    T3Text1: '每一個新訂購月租泊車服務的客戶，將會獲發一張月票、智能咭、遙控器或其他指定憑證。',
    T3Text2:
      '客戶若未能以指定方式進場或離場而要求人手起閘放行，本公司必須記錄客戶的個人資料及收取相當於該停車場一小時的時租費用。',
    T3Text3:
      '客戶於終止月租泊車服務後三個月內須退還智能咭或遙控器，否則本公司將向客戶收取不可退還的手續費用港幣二百元正。',
    T3Text4:
      '若客戶遺失了或損毁月票、智能咭、遙控器、指定憑證而必須安排補發/更換/更新，手續費為港幣二百元正。月票、智能咭、遙控器或指定憑證於報失後即告失效並且不會獲退款或任何賠償。若客戶之月票、智能咭、遙控器或指定憑證因自然損毀而未能正常使用，則可獲免費補發/更換/更新。',
    T4Title: '4. 轉換車牌號碼',
    T4Text1: '月租泊車服務只供一輛已登記之車輛於指定時限在指定的停車場內停泊。',
    T4Text2:
      '任何未登記之車輛違例使用相關的月租泊車服務均會導致其月租泊車服務被終止並且不會作出任何賠償，而相關按金(如有)亦不會被退還。',
    T4Text3:
      '客戶如須更新登記之車輛，必須於該車輛進場前辦理短暫或永久轉換車牌號碼的手續，每一個月內只可申請轉換車牌號碼一次。',
    T4Text4:
      '短暫轉換車牌號碼為期最多連續五日，手續費用全免。如超過五日，暫替的車輛須由第六日起繳付時租泊車費用。',
    T4Text5:
      '永久轉換車牌號碼的不可退還手續費為港幣五十元正。如客戶於續購月租泊車服務時辦理相關的永久轉換，手續費則可獲豁免。',
    T5Title: '5. 其他事項',
    T5Text1: '在停車場內嚴禁洗車、打蠟或進行車輛維修。',
    T5Text2:
      '客戶不可放置雜物於停車場內，本公司有權移走任何未經許可而放置於停車場內之雜物而不作另行通知。',
    T5Text3: '停車場內之消防喉只可作救火用途，嚴禁作其他用途。',
    T5Text4: '本公司並不保證提供電動車充電站及/或電動車充電器及/或電動車充電系統予客戶使用。',
    T5Text5:
      '本公司無須對於一切因停車場閘機系統及/或免觸式泊車系統及/或停車場升降機及/或機械泊車設施及/或其他設施發生故障或失靈或車牌號碼或資料未更新時導致的任何損失、索償或損壞負責或作出任何賠償。',
    T5Text6: '本公司恕不提供任何月租泊車或車輛的出入記錄。',
    T5Text7: '付款收據恕不補發。',
    T5Text8: '已訂購月租泊車服務的車輛須持有效的車輛登記文件。',
    T5Text9:
      '鑑於免觸式泊車系統的性質和特點，特別是可以毋須使用月票、智能咭、遙控器或指定憑證進入及離開停車場的特點，客戶在使用免觸式泊車系統方式進出停車場時應該採取適當預防措施，避免其車輛或於其車輛內外的任何貨品、物品或器具有所損失或損壞。客戶須確保車輛停放在停車場時有效的防盜警報系統處於完全有效狀態。為保證車輛安全而提供的所有其他保護措施亦應保持在良好及完全有效狀態。車輛無人看管時，所有車門均應完全鎖定。離開車輛時所有車匙或智能鑰匙都應拔除並且不應留在車裡無人看管。本公司不會因客戶使用免觸式泊車系統導致車輛及/或財物的任何損失、索償或損壞(包括車輛盜竊)負責或作出任何賠償。',
    T5Text10:
      '本公司可修訂、補充或刪改本“月租客戶須知”及“泊車及使用條款”或其他條件及細則之任何部份或全部或制訂新條件及/或細則。新條件及/或細則於張貼在本公司網站、手機應用程式及停車場顯眼地方時立即生效及對任何使用本公司服務之車輛，其車主及/或使用者及/或月租客戶有約束力。',
    T6Title: '< 交付政策 >',
    T6Text1:
      '1. 新月租客戶會獲發一張月票、智能咭、遙控器或其他指定憑證以便進出所選定的停車場。停車場工作人員將聯繫客戶安排送遞月票、智能咭、遙控器或其他指定憑證的時間及地點。客戶亦可以要求以快遞收取，需時至少兩天。',
    T6Text2:
      '2. 如未有續訂月租，有關的月票、智能咭、遙控器或其他指定憑證有效期為付費月份的最後一天。',
  },

  Prefix: {
    Select: 'Please Select',
    Mr: '先生',
    Mrs: '太太',
    Ms: '女士',
  },

  Language: {
    zh: '中文',
    en: '英文',
  },

  Selector: {
    Region: '選擇地區',
    District: '選擇區域',
  },

  Map: {
    'i-Monthly': '設 i-Monthly 預訂月租服務',
    'REFINE SEARCH': '進階搜尋',
    'Search by Address': '地址搜尋',
    'Search by Region': '地區搜尋',
    Region: '地區',
    District: '區域',
    Directions: '顯示路線',
    Phone: '電話',
    Reset: '重設搜索',
    search: '輸入地址...',
    getDirections: '從這裡出發的路線...',
    goolemapOpen: '從Google地圖中開啟',
    clearDirections: '清除方向',
  },

  CarParkDetail: {
    PHOTO: '相片',
    MAP: '地圖',
    'STREET VIEW': '街景',
    PaymentMethod: '付款方法',
    Book: '預訂',
    Full: '額滿',
    Address: '地址',
    Phone: '電話',
    Remark: '備注',
    BackToMap: '返回地圖',
    DistrictCarParks: '更多同區車場',
    iHourlyFAQ: 'i-HOURLY預訂時租指南及常見問題',
    iMonthlyFAQ: 'i-MONTHLY預訂月租指南及常見問題',
    Booking: {
      SelectPrompt: '選擇月租服務期',
      FromToday: '由今日起',
      FromTodayHint: '如選擇於今日開始使用月租服務，您需預繳下月之月租服務費用。',
      FromNextMonth: '由下月起',
      to: '至',
      Next: '下一步',
      Reserved: '固定車位',
      NonReserved: '非固定車位',
      errorMsg: '服務有效日期錯誤,請聯絡客戶服務中心',
    },
    isBookable: '請於停車場辦事處查詢申請詳情',
    Hour12: '由入閘時間起計算至同日午夜十二時止',
    Hour24: '每24小時之最高收費',
    MaxPark: '由入車時間起計算至同日午夜十二時止',
    freeCarParking: '免費泊車: ',
    monthly: '月租服務',
  },

  Cart: {
    Instructions: {
      Header: '請細閱',
      '1-1': `預訂時，所選服務將於購物車儲存15分鐘。如未能於15分鐘內完成交易，該服務將會從購物車中被移除，並提供予其他客戶預訂。`,
      '1-2': `每一個車輛登記號碼只能在同一個停車場享有一項月租服務。`,
      '2-1': `請小心檢查以下資料，預訂一經確認後將不能更改或取消。`,
    },
    timeUp: '本交易已閒置超過15分鐘，請重新載入網頁或重試。',
    close: '關閉',
    expired: '已逾時',
    paymentExpired: '付款時限已過',
    retry: '請返回並重試。',
    InstructionHeader: '',
    Instruction1: ``,
    Instruction2: ``,
    BackMessage: '如按「返回」，您所選的服務將會提供予其他客戶預訂。',
    EmptyMessage: '你的購物車裡沒有物品',
    DetailHeader: '車位詳情',
    BackToService: '回到服務記錄',
    BookMore: '預訂更多',
    Next: '下一步',
    Back: '返回',
    Confirm: '確認',
    Remove: '移除',
    ConfirmRemove: '您確定要從購物車中刪除此項目嗎？',
    ConfirmChange: '您確定要更改你的車輛登記號碼嗎？',
    contantYou: '我們當盡快告知  閣下領取月租咭的安排。',
    contantAddress: '多謝使用本公司月租車位服務！',
    ChangeSuccess: '更改完成',
    BookingTypeTitle: '預訂類別',
    ServiceTitle: '服務',
    ServicePeriodTitle: '服務有效日期',
    monthlyPeriodTitle: '當月服務有效日期',
    CarTitle: '指定車輛',
    ChangeCar: '更改',
    RemoveCar: '移除車輛',
    Price: '價錢',
    ServiceFee: '服務金額',
    HandlingFee: '手續費',
    Summary: '預訂概要',
    IMonthly: {
      step1Title: '更改車輛登記號碼',
      step1Text1: '顧客每月可以短暫更改車輛登記號碼一次，使用期限為五天，費用全免。',
      step1Text2:
        '如於月租服務期間需永久更改車輛登記號碼，顧客需繳付行政費港幣50元正，如於續訂月租服務時更改，該費用將獲豁免。',
      step1Text3: '更新之車輛必需為同類型車輛',
      iParkRemarks:
        '如果您已啟動 iPark 服務，請在威信停車場手機應用程式的「管理車輛」中更新您的車輛資訊。',
      stlectType: '選擇更新項目',
      temporary: '短暫更改（費用全免，使用期限為5天，即日生效）',
      permanent: '永久更改（需繳需行政費用50元正）',
      VRH: '車輛登記號碼',
      newVRH: '更新後車輛登記號碼',
      startDate: '開始日期',
      today: '即日',
      step2Title: '更改指定車輛詳情',
      originalVRH: '原有指定車輛',
      new: '新指定車輛',
      fee: '行政費',
      all: '所有交易均以港元結算',
    },
    PickUpMethod: {
      Prompt: '領取「PARK泊CARD」方法',
      Title: '領取方法',
      Self: '自行領取',
      Courier: '速遞',
      LocationPrompt: '請選擇地點',
    },
    PaymentMethod: {
      ChoosePrompt: '選擇付款方法',
      HKDDisclaimer: '所有交易均以港元結算。',
      'VISA/MasterCard': '以VISA卡/萬事達卡付款',
      PPS: '以繳費靈付款',
      FPS: '以FPS付款',
      SavedCard: '已儲存付款方式（信用卡）',
      NewCard: '使用其他信用卡',
      Cheque: ' 支票',
      '7-11': '7-11',
    },
    TnC: {
      Title: '條款及細則',
      Content: `<p><span style="text-decoration-line: underline;">&lt; 有關訂購及使用月租泊車服務之條款及細則&gt;</span></p><p>&nbsp;</p><p>新購或續購月租泊車服務的客戶須接受及遵守張貼於威信停車場管理(控股)有限公司(以下簡稱&ldquo;本公司&rdquo;) 停車場入口的&ldquo;泊車及使用條款&rdquo;，或張貼於本公司網站(&ldquo;www.wilsonparking.com.hk&rdquo;)、手機應用程式及停車場內之其他條件及細則。否則本公司有權終止其月租泊車服務並且不會作出任何賠償。</p><p>&nbsp;</p><p>1. 訂購月租泊車服務</p><p>&nbsp;</p><p>-新月租客戶訂購月租泊車服務時要視乎車位供應情況，客戶可透過本公司網站或手機應用程式登入/註冊為月租客戶及使用指定的電子支付模式或其他方式(如適用)繳付首月費用。</p><p>&nbsp;</p><p>-訂購月租泊車服務的首月費用：當月15號或之前訂購，須繳付整月的月租泊車服務費用；當月16號至21號訂購，須繳付半個月的月租泊車服務費用；當月22號至月底訂購，須同時繳付半個月的月租泊車服務費用及下一個月整月的月租泊車服務費用。</p><p>&nbsp;</p><p>-客戶於本公司網站或手機應用程式預訂新月租泊車服務的過程中，所選月租泊車服務將預留15分鐘以便於此時段內完成預訂程序，當客戶於預訂程序中途取消預訂或過程超越15分鐘，所選之預訂月租泊車服務將被取消。客戶於網上繳費時將被轉至第三方機構付款平台進行安全支付程序，包括但不限於VISA咭、萬事達咭、快速支付系統（轉數快）和繳費靈，需要遵守相關的條款，本公司不承擔該支付服務所引致的任何責任。本公司沒有及亦不會保存客戶提供予第三方機構的相關付款資料。</p><p>&nbsp;</p><p>-一個車牌號碼於同一停車場，只可訂購一項月租泊車服務。</p><p>&nbsp;</p><p>-現有客戶可透過本公司網站或手機應用程式內的「我的帳戶」管理個人資料及可於每月二十二日至月底期間使用指定的電子支付模式續購下月份之月租泊車服務。閣下所提供的個人及其他有關資料會用於處理日常之月租泊車服務。若客戶未能提供或沒有提供足夠或正確的資料有可能會影響本公司向閣下於本
公司網站或手機應用程式上列明之服務。客戶可於閣下的帳戶內查閱或修改個人及其他資料。及時更新個人及其他資料十分重要，可確保閣下的月租泊車服務不會受到不必要的中斷。</p><p>&nbsp;</p><p>-凡欲於7-11便利店以現金或匯豐銀行「入票易」機以支票(劃線支票抬頭請填寫&lt;威信停車場管理(控股)有限公司&gt;)繳付月租泊車服務費用，必須於月租到期前最少三個工作天繳付。</p><p>&nbsp;</p><p>-如月租泊車服務於到期前仍沒有辦理續購，月租泊車服務將會自動終止，而該月租泊車服務的配額將會分發給其他客戶。客戶在月租泊車服務到期後欲再訂購，將被當作新月租客戶訂購月租泊車服務，並視乎當時的月租泊車服務供應而定。凡未有續購仍逾期停留於停車場內之車輛將由到期日後起按時租收費。</p><p>&nbsp;</p><p>-月租泊車服務費用一經繳付，不論有否使用服務均不獲退款。</p><p>&nbsp;</p><p>-客戶只可駕駛已經登記的車輛及持有效之月票、智能咭、遙控器或使用免觸式泊車系統或其他指定方式進出停車場。</p><p>&nbsp;</p><p>&nbsp;</p><p>2. 月租泊車服務之有效期限</p><p>&nbsp;</p><p>-月租泊車服務將於所訂購/續購的月租泊車服務期限內有效。整月月租泊車服務之有效期為每月首日之零時零分起至每月最後一日之晚上十一時五十九分為止。</p><p>&nbsp;</p><p>&nbsp;</p><p>3. 使用月租泊車服務(適用於設有自動閘機系統的停車場)</p><p>&nbsp;</p><p>-每一個新訂購月租泊車服務的客戶，將會獲發一張月票、智能咭、遙控器或其他指定憑證。</p><p>&nbsp;</p><p>-客戶若未能以指定方式進場或離場而要求人手起閘放行，本公司必須記錄客戶的個人資料及收取相當於該停車場一小時的時租費用。</p>
<p>&nbsp;</p><p>-客戶於終止月租泊車服務後三個月內須退還智能咭或遙控器，否則本公司將向客戶收取不可退還的手續費用港幣二百元正。</p><p>&nbsp;</p><p>-若客戶遺失了或損毁月票、智能咭、遙控器、指定憑證而必須安排補發/更換/更新，手續費為港幣二百元正。月票、智能咭、遙控器或指定憑證於報失後即告失效並且不會獲退款或任何賠償。若客戶之月票、智能咭、遙控器或指定憑證因自然損毀而未能正常使用，則可獲免費補發/更換/更新。</p><p>&nbsp;</p><p>&nbsp;</p><p>4. 轉換車牌號碼</p><p>&nbsp;</p><p>-月租泊車服務只供一輛已登記之車輛於指定時限在指定的停車場內停泊。</p><p>&nbsp;</p><p>-任何未登記之車輛違例使用相關的月租泊車服務均會導致其月租泊車服務被終止並且不會作出任何賠償，而相關按金(如有)亦不會被退還。</p><p>&nbsp;</p><p>-客戶如須更新登記之車輛，必須於該車輛進場前辦理短暫或永久轉換車牌號碼的手續，每一個月內只可申請轉換車牌號碼一次。</p><p>&nbsp;</p><p>-短暫轉換車牌號碼為期最多連續五日，手續費用全免。如超過五日，暫替的車輛須由第六日起繳付時租泊車費用。</p><p>&nbsp;</p><p>-永久轉換車牌號碼的不可退還手續費為港幣五十元正。如客戶於續購月租泊車服務時辦理相關的永久轉換，手續費則可獲豁免。</p><p>&nbsp;</p><p>&nbsp;</p><p>5. 其他事項</p><p>&nbsp;</p><p>-在停車場內嚴禁洗車、打蠟或進行車輛維修。</p><p>&nbsp;</p><p>-客戶不可放置雜物於停車場內，本公司有權移走任何未經許可而放置於停車場內之雜物而不作另行通知。</p>
<p>&nbsp;</p><p>-停車場內之消防喉只可作救火用途，嚴禁作其他用途。</p><p>&nbsp;</p><p>-本公司並不保證提供電動車充電站及/或電動車充電器及/或電動車充電系統予客戶使用。</p><p>&nbsp;</p><p>-本公司無須對於一切因停車場閘機系統及/或免觸式泊車系統及/或停車場升降機及/或機械泊車設施及/或其他設施發生故障或失靈或車牌號碼或資料未更新時導致的任何損失、索償或損壞負責或作出任何賠償。</p><p>&nbsp;</p><p>-本公司恕不提供任何月租泊車或車輛的出入記錄。</p><p>&nbsp;</p><p>-付款收據恕不補發。</p><p>&nbsp;</p><p>-已訂購月租泊車服務的車輛須持有效的車輛登記文件。</p><p>&nbsp;</p><p>-鑑於免觸式泊車系統的性質和特點，特別是可以毋須使用月票、智能咭、遙控器或指定憑證進入及離開停車場的特點，客戶在使用免觸式泊車系統方式進出停車場時應該採取適當預防措施，避免其車輛或於其車輛內外的任何貨品、物品或器具有所損失或損壞。客戶須確保車輛停放在停車場時有效的防盜警報系統處於完全有效狀態。為保證車輛安全而提供的所有其他保護措施亦應保持在良好及完全有效狀態。車輛無人看管時，所有車門均應完全鎖定。離開車輛時所有車匙或智能鑰匙都應拔除並且不應留在車裡無人看管。本公司不會因客戶使用免觸式泊車系統導致車輛及/或財物的任何損失、索償或損壞(包括車輛盜竊)負責或作出任何賠償。</p><p>&nbsp;</p><p>-本公司可修訂、補充或刪改本&ldquo;月租客戶須知&rdquo;及&ldquo;泊車及使用條款&rdquo;或其他條件及細則之任何部份或全部或制訂新條件及/或細則。新條件及/或細則於張貼在本公司網站、手機應用程式及停車場顯眼地方時立即生效及對任何使用本公司服務之車輛，其車主及/或使用者及/或月租客戶有約束力。</p><p>&nbsp;&nbsp;</p><p>&nbsp;</p><p><span style="text-decoration: underline;">&lt; 交付政策&gt;</span></p>
<p>&nbsp;</p><p>1. 新月租客戶會獲發一張月票、智能咭、遙控器或其他指定憑證以便進出所選定的停車場。停車場工作人員將聯繫客戶安排送遞月票、智能咭、遙控器或其他指定憑證的時間及地點。客戶亦可以要求以快遞收取，需時至少兩天。</p><p>&nbsp;</p><p>2. 如未有續訂月租，有關的月票、智能咭、遙控器或其他指定憑證有效期為付費月份的最後一天。</p><p>&nbsp;</p><p>&nbsp;</p><p><span style="text-decoration: underline;">&lt; 私隱政策聲明&gt;</span></p><p>&nbsp;</p><p>1. 以下是威信停車場管理(控股)有限公司、其附屬公司與聯營公司(以下簡稱「本公司」)根據《個人資料(私隱)條例》(第486章)之規定所訂之私隱政策聲明。我們將確保我們之職員將執行有關政策，嚴格保密你的個人資料。</p><p>&nbsp;</p><p>2. 本公司保障客戶及本網站用戶所提供之一切資料。除於會籍申請、會籍續期、會籍/戶口維護、登記電郵地址、網上支付本公司的產品、使用汽車地理位置導航服務、及提供/收集網上意見服務時，我們可能需要收集其個人資料及記錄用戶電腦的網路位址外，我們不會於用戶瀏覽網站時收集任何足以識別個人身份之資料。當用戶瀏覽網站時，我們僅將其瀏覽記錄為一次按動次數，而不收集任何個人資料。而此等資料將用於編備有關我們網站使用情況之一般統計資料。</p><p>&nbsp;</p><p><span style="text-decoration-line: underline;">使用Cookies檔案</span></p><p>&nbsp;</p><p>我們在網站上使用cookies以提高網站的性能和增強閣下的在線體驗。我們使用Session cookies令閣下可瀏覽及使用網站上的基本功能，例如保留登入資料並減少在互聯網上資料傳遞的需要。我們使用Google Analytics識別重訪用戶以使我們能夠更好地了解用戶如何瀏覽我們的網站及瀏覽網站所花的時間和頻率，從而改善我們的網站。閣下瀏覽我們的網站時，我們使用Font size cookies來提供適當的字符外觀。我們在使用cookies時，將不會向閣下收集任何個人資料。</p><p>&nbsp;</p>
<p>任何個人資料的收集將按本公司的《個人資料收集聲明》的條款所進行。個人資料將會安全穩妥儲存於我們的系統內，而本公司將採取所有切實可行的步驟，以確保個人資料的保存時間不超過將其保存以貫徹該資料被使用於或會被使用於的目的(包括任何直接有關的目的)所需的時間。只有經培訓及獲授權的職員才可獲准查閱該等個人資料，除《個人資料收集聲明》所載之人士除外，我們不會向任何本公司以外的人士發佈該等個人資料，用戶有權根據載於《個人資料收集聲明》的程序，要求存取及更正其個人資料。</p><p>&nbsp;</p><p>本公司可不時根據用戶之個人資料向他們寄出宣傳產品及服務之直接市場推廣訊息。在直接市場推廣過程中，我們將提供適當之「拒絕服務選擇」。</p><p>&nbsp;</p><p>本公司將竭盡所能，確保用戶之私隱獲得妥善保障。然而，鑑於互聯網之性質，我們不能擔保可以做到「完全保障」。</p><p>&nbsp;</p><p>本公司會起用第三者內容供應商及服務供應商，並提供接駁其他網站之連結。此等第三者可於用戶使用其服務時收集有關用戶之個人資料。此等第三者將依其私隱政策行事，而我們的《私隱政策聲明》及《個人資料收集聲明》並不涵蓋該等第三者。</p><p>&nbsp;</p><p>用戶如對我們之私隱政策及慣例有任何疑問，請電郵<span style="text-decoration: underline;">info@wilsonparking.com.hk</span> 往威信停車場管理(控股)有限公司，或投寄到新界葵涌興芳路新都會廣場第一座2901室收。</p><p>&nbsp;</p><p>&nbsp;</p><p><span style="text-decoration: underline;">&lt; 個人資料收集聲明&gt;</span></p><p>&nbsp;</p><p>本聲明乃遵照《個人資料(私穩)條例》(第486章)的要求而發出，通知閣下收集資料的目的、閣下同意我們如何使用這些資料和及閣下的權利。本聲明會不時更改，故請定期查閱。閣下登記使用我們之服務及每次登入我們網站，即表示同意接受當時生效之個人資料收集聲明。</p><p>&nbsp;</p><p><span style="text-decoration-line: underline;">資料之收集</span></p>
<p>&nbsp;</p><p>在使用我們網站之時，閣下可能會被要求向我們提供個人識別資料，例如姓名、電話號碼、電郵地址及信用咭資料等。為向閣下提供本網站之各項服務及活動，該些資料是必要的。倘若閣下未能提供所需資料，我們將不能向閣下提供我們網站上可供享用之服務及活動。</p><p>&nbsp;</p><p>我們可能記錄訪問本網站所使用的電腦的網路位址。</p><p>&nbsp;</p><p><span style="text-decoration-line: underline;">資料之目的及用途</span></p><p>&nbsp;</p><p>我們所收集之資料將用作以下用途：</p><p>&nbsp;</p><p>-監控本網站之運作及協助本網站之未來發展</p><p>&nbsp;</p><p>-匯編有關我們之用戶之整體統計資料以作關於網站使用的分析</p><p>&nbsp;</p><p>-為有意註冊本網站上所提供的服務的用戶設立戶口及維護其戶口</p><p>&nbsp;</p><p>-為有意申請入會的用戶註冊會籍及維護其會籍</p><p>&nbsp;</p><p>-識別和核實使用本網站所提供服務的用戶的身份</p><p>&nbsp;</p><p>-就有關或因使用本網站上所提供的服務發生的事項與用戶溝通</p><p>&nbsp;</p><p>-為本公司進行研究及/或分析</p><p>&nbsp;</p><p>-不時向用戶提供關於本公司的資訊，包括本公司為用戶提供的產品、設施、服務及其他優惠、奬賞及其他得益的資訊</p><p>&nbsp;</p><p>-對查詢、建議、投訴及索償的處理及跟進</p><p>&nbsp;</p><p>-為更瞭解客戶的需要而進行服務抽樣調查</p><p>&nbsp;</p><p>-改善產品及服務以迎合客戶及/或完善向客戶所發出的資料</p>
<p>&nbsp;</p><p>我們有意使用閣下的姓名、聯繫資料和任何與可能感興趣的商品和服務有關的資料，提供閣下可能有興趣的資訊，包括有針對性的橫幅廣告、新服務和產品和其他優惠並進行直接促銷，包括產品、服務、諮詢、意見和與停車場服務有關的促銷標的。我們還有意而閣下亦同意，為上述目的轉移和提供上述資料予在香港以內和以外我們的母公司、附屬公司、聯營公司或關聯公司、或本公司控制或共同控制的公司、和協助本公司為閣下提供各項產品、設施、服務及其他其他優惠、獎賞或其他得益的供應商。如無閣下的同意，我們則不能如上使用或向該些機構提供上述資料。閣下可在向我們網站提供資料時表示同意，或以書面向我們表示同意，不另收費。</p><p>&nbsp;</p><p><span style="text-decoration-line: underline;">資料之轉移</span></p><p>&nbsp;</p><p>除了為上述目的使用有關資料時，合理而有需要把有關資料轉移予的相關人仕及機構外，我們不會以可識別閣下之方式向任何其他人士披露或傳遞閣下之資料。</p><p>&nbsp;</p><p><span style="text-decoration-line: underline;">使用Cookies檔案</span></p><p>&nbsp;</p><p>我們在網站上使用cookies以提高和增強閣下的在線體驗。我們使用Session cookies令閣下可瀏覽及使用網站上的基本功能，如保留登入資料可減少在互聯網上資料傳遞的需要。我們使用Google Analytics於識別重訪用戶瀏覽我們的網站，以使我們能夠更好地了解用戶如何瀏覽並通過我們的網站，所花的時間和頻率，從而可改進我們的網站。當閣下瀏覽我們的網站時，我們使用Font size cookies來提供適當的字符外觀。我們在使用cookies時，將不會向閣下收集任何個人資料。</p><p>&nbsp;</p><p><span style="text-decoration-line: underline;">資料之查閱</span></p><p>&nbsp;</p><p>閣下有權根據《個人資料（私隱）條例》(第486章)的規定，要求查閱或更正閣下之個人資料。如有任何查閱或更正資料的要求，請電郵<span style="text-decoration: underline;">info@wilsonparking.com.hk</span> 或投寄到新界葵涌興芳路新都會廣場第一座2901室收。</p><p>&nbsp;</p>
<p>本公司感謝貴客戶長期支持，我們不時與貴客戶分享本公司的各種最新資訊。如貴客戶不願意收取本公司的直接促銷材料及/或資訊，可以向我們發出書面通知寄：新界葵涌興芳路新都會廣場第一座2901室收或電郵至：<span style="text-decoration: underline;">info@wilsonparking.com.hk</span>。</p><p>&nbsp;</p><p>&nbsp;</p><p><span style="text-decoration: underline;">&lt; 資料保密政策&gt;</span></p><p>&nbsp;</p><p>保護您資訊的安全對我們非常重要。我們使用傳輸層安全（TLS）高級技術來加密客戶的私人資訊，以便在資訊通過互聯網傳輸時不會被讀取。由於&ldquo;HTTPS&rdquo;會顯示在我們的網址中，因此可以通過按一下流覽器欄上的鎖定符號來查看安全證書的詳細資訊。客戶於網上繳費時將被轉至第三機構付款平台進行VISA咭，萬事達咭和繳費靈的安全支付程序，本公司沒有及亦不會保存客戶提供予第三機構的相關付款資料。</p><p>&nbsp;</p><p>此乃中文譯本，如有任何爭議，一切以英文為準。</p><p>&nbsp;</p>`,
      Agree: '我同意並接受條款及細則。',
    },
    Discount: '折扣代碼',
    Apply: '使用',
    SubTotal: '金額',
    BookingTypes: {
      New: '新服務',
      Renew: '續訂',
      Change: '變更',
    },
    TotalPrice: '總金額',
    Steps: {
      Step1: '填寫資料',
      Step2: '確認資料',
      Step3: '付款',
      Step4: '完成',
    },
    ProgressBar: {
      Title: '購物車',
      Tutorial: '指南及常見問題',
      ContactUs: '聯絡我們',
    },
    CarRecord: {
      title: '車輛記錄',
      carType: '車輛類型 ',
      VRH: '車輛登記號碼 ',
      fillError: '請填寫以下所有資料。',
      addCar: '添加車型',
      create: '新增',
      invalidLPN: '請輸入正確的車輛登記號碼',
    },
    FPS: {
      forMobile: '[手機用戶] 請先用螢幕截圖儲存此二維碼。',
      text1: '用手機開啟您指定銀行之應用程式。',
      text2: `登入銀行帳戶並開啟「轉數快付款」。`,
      text3: '[手機用戶] 上載已儲存的二維碼截圖後繼續付款。',
      text4: '[電腦用戶] 以手機掃描以上二維碼，然後繼續付款。',
      complete: '完成付款',
      back: '返回主頁',
      onlyPeriod: '只限 {{period}} 月租服務',
    },
    PPS: {
      read: '請細閱',
      text1: '您的訂單正在處理中。請稍侯...',
      text2: '預訂尚未完成，請不要關閉視窗。',
      text3: '請於繳費彈窗付款。',
    },
    locationPickupError: '請選擇地點',
    timeupTitle: 'Booking service expired',
    timeupText1:
      ' Since you’ve left your transaction idled for 15 minutes, your selected services are now released from the cart to be made available for other customers.',
    timeupText2:
      'Please go back and book your desired service should you wish to go through the transaction again.',
    Separate: '您所選的停車場不能同時付款，請移除部分項目後再試。',
    support: '支付方法',
    expiredItemRemind: '您選擇的服務時段不適用並會被移除。請重新選擇。',
    multipleReminder: '您的購物車內有多於一項服務，請細心檢查各項服務才確認付款。',
    existingBooking: '揀選的車牌已是此停車場登記月租車輛。請重新選擇。',
    pleasePress: '如進出車場時遇上問題, 請按閘機上的',
    atTheEntry: '按鈕尋求協助。',
    locationText1: '有關月租服務之安排',
    locationText2: '成功付款後，我們將盡快與您聯繫，確認有關月租服務之安排。',
  },
  Timer: {
    TimeLeft: '剩餘時間',
  },
  IhourlyCart: {
    Title: 'i-HOURLY預訂時租',
    DetailTitle: '請細閱',
    DetailText1: '1.預訂服務將由預訂入場時間起1小時內有效。',
    DetailText2: '2. 需繳付相關泊車費用及港幣0元正手續費。(現於推廣期內，手續費將獲豁免)',
    Region: '地區',
    District: '區域',
    Carpark: '停車場',
    Type: '車輛類型',
    Prefix: '稱謂',
    Name: '名字',
    FirstNameEng: '名字（英文）',
    LastNameEng: '姓氏（英文）',
    Email: '電郵地址',
    Phone: '手提電話號碼',
    VehicleRegistrationMark: '車輛登記號碼',
    Date: '日期及時間',
    EntryDate: '入場日期 ',
    EntryDateinfo: '輸入的日期應為',
    EntryDateinfo1: '及',
    EntryDateinfo2: '之間',
    EntryTime: '入場時間',
    EntryTimeinfo: '最少24小時前預訂',
    CustomerDetails: '顧客資料',
    SignBoxTitle: 'i-MONTHLY月租用戶登入',
    SignBoxText: '在此登入更省時',
    Username: '用戶名稱',
    Password: '密碼',
    Login: '登入',
    EntryHourError: '入場時間無效',
    EntryMinsError: '入場分鐘無效',
    EntryDateError: '入場日期無效',
    LoginError: '請輸入有效的登入資料',
    StepText1: '1.請小心檢查以下資料，預訂一經確認，不能取消及退款。',
    StepText2:
      '2.下列收費只供參考，實際收費依據當時停車場收費而定，請留意在停車場入口展示之停車場收費表。',
    Hourly: '時租 (每小時)',
    Service: '服務',
    Time: '時間',
    ParkingRate: '泊車費用',
    DateTime: '日期及時間',
    PaymentTitle: '付款',
    HandlingFree: '手續費用：港幣1元正',
    HandlingFreeText: '實際泊車費用將於您離開停車場時結算。',
    PaymentMethodText: '所有交易均以港元結算。',
    OtherMethod: '其他付款方法',
    VisaText:
      '此付款方式將安全地被儲存作下次交易之用，您可於「我的用戶資料」中移除已儲存的付款方式。',
    Terms: '條款及細則',
    Visa: '以VISA卡/萬事達卡付款',
    PPS: '以繳費靈付款',
    FPS: '以FPS付款',
    SavedPayment: '已儲存付款方式（信用卡）',
    OtherCard: '使用其他信用卡',
    Next: '下一步',
    Back: '返回',

    TermsTitle1: 'i-MONTHLY 預訂月租',
    iMonthlyT1:
      '使用i-Monthly月租服務或其它月租服務須接受及遵守張貼於威信停車場管理(控股)有限公司(以下簡稱“本公司”) 停車場入口的“泊車及使用條款”，或張貼於網頁，應用程式及停車場內之其他條件及細則。',
    iMonthlyT2:
      '本公司可修訂、補充或刪改“泊車及使用條款”或其他條件及細則之任何部份或全部或制訂新條件及/或細則。新條件及/或細則於張貼在網站，應用程式及停車場顯眼地方時立即生效及對任何使用月租服務之車輛之車主及/或使用者及/或客戶有約束力。',
    iMonthlyT3:
      '客戶可以在選定的停車場預訂新月租服務；若所選的停車場未能提供合適的月租服務，客戶可選取其他停車場或其他月租服務。如客戶在每月15號或之前預訂新月租服務須繳付整月的月租服務費用；若在16號或以後預訂新月租服務則須繳付半個月的月租服務費用。客戶在預訂新月租服務的過程中，所選月租服務將預留15分鐘以便於此時段內完成預訂程序，當客戶於預訂程序中途取消預訂或過程超越15分鐘，所選之預訂月租服務將被取消。如預訂固定車位月租服務，本公司員工將於成功預訂服務後聯絡客戶安排可選用的固定車位。每一個新月租服務將獲發Park泊Card一張，客戶可透過速遞或親身前往指定地點領取。現有客戶如使用同一車輛登記號碼，於其他停車場預訂新月租服務，客戶可使用其現有的Park泊Card進出。',
    iMonthlyT4:
      '一個車輛登記號碼於同一車場，只可訂購一項月租服務。月租服務之有效期限為每月首日之零時零分起至每月最後一日之晚上十二時止。',
    iMonthlyT5:
      '客戶可於每月二十二日至月尾期間續訂下月份之月租服務。如月租服務於屆滿時沒有辦理續訂，月租服務將會自動終止而該月租服務配額將會分發給其它客戶。客戶在月租服務終止後欲再預訂該月租服務，將被當作預訂新月租服務，並視乎預訂時月租服務供應而定。續訂月租服務最多以不超過一個月為限。',
    iMonthlyT6: '客戶可於月租服務期限屆滿前終止其月租服務。',
    iMonthlyT7:
      '所有交易將以港元（港元$）處理，並接受客戶於網上使用VISA咭，萬事達咭和繳費靈繳費。客戶亦可以在7-11店鋪或通過匯豐銀行支票存款機之賬單支付服務費。客戶於網上繳費時將被轉至第三機構付款平台進行VISA咭，萬事達咭和繳費靈的安全支付程序，並需要遵守相關的條款，本公司不承擔該支付服務所引致的一切責任。本公司沒有及亦不會保存客戶提供予第三機構的相關付款資料。',
    iMonthlyT8:
      '月租服務祗供已登記之車輛於指定的停車場內使用，任何非登記車輛違例使用之月租服務會被終止，並不會作出賠償，而按金(如有)亦不會被退還。客戶可於網上辦理永久或短暫轉換車輛登記號碼。短暫轉換為期最多五日及手續費用全免。如超過五日，暫替的車輛須由第六日起繳付時租泊車費。客戶只可每一個月內申請短暫轉換車輛登記號碼一次。於月租服務使用期間，永久轉換車輛登記號碼的手續費為港幣五十元正。如客戶於續訂月租服務時辦理相關的永久轉換，手續費則可獲括免。',
    iMonthlyT9:
      '閣下所提供的個人及其他有關資料會用於處理日常i-Monthly之月租服務。若客戶未能提供或沒有提供足夠或正確的資料有可能會影響本公司向閣下於網站或應用程式上列明之服務。客戶可於閣下的i-Monthly戶口內查閱或俢改個人及其他資料。及時更新個人及其他資料十分重要，可確保閣下的月租服務不會受到不必要的中斷。',
    iMonthlyT10:
      '客戶必須以有效之Park泊Card進/出車場。客戶若在離場時要求人手起閘，本公司會記錄客戶的個人資料及收取相當於一小時的時租費用。',
    iMonthlyT11: '月租服務費用一經繳付，恕不接受退款。',
    iMonthlyT12:
      '若客戶遺失Park泊Card或由於人為因素導致Park泊Card失效，客戶需要繳付補領費用港幣二百元正。Park泊Card於報失後即告失效，客戶不能用作要求退回款項，申索或賠償。若客戶之Park泊Card是自然損耗或磁帶故障而失效，可獲免費補發。',
    iMonthlyT13:
      '客戶於終止月租服務後需退還Park泊Card，否則本公司將向客戶收取不可退還的行政費用港幣二百元正。',
    iMonthlyT14: '在停車場內嚴禁清洗、打蠟或維修車輛。',
    iMonthlyT15:
      '客戶不可放置任何雜物於停車場內，本公司有權移走任何未經許可而放置於停車場內之雜物，而不作另行通知。',
    iMonthlyT16: '車場內之消防喉只可用作救火用途，嚴禁作其他用途。',

    TermsTitle2: 'i-HOURLY 預訂時租',
    iHourlyT1: '客戶可於24小時前開始預訂時租車位。',
    iHourlyT2: '預訂服務將由預訂入場時間起1小時內有效。停車場工作人員將會為您預留適當的泊車位置。',
    iHourlyT3: '客戶需遵從停車場的泊車及使用條款。',
    iHourlyT4: '手續費將不設退款。',
    iHourlyT5: '當您到達停車場時，停車場工作人員將會為您提供適切的服務。',

    TermsTitle3: '交付政策',
    DELIVERYT1:
      '新月租客戶會獲提供一張Park泊Card進出所選定的停車場。停車場工作人員將聯繫客戶安排時間及地點送遞Park泊Card，並亦可以安排快遞予客戶，但需時不多於二天內。',
    DELIVERYT2: '續訂月租其Park泊Card的有效期為付費月份的最後一天。',
    DELIVERYT3: '預定i-Hourly的客戶抵達停車場時，停車場工作人員會提供協助。',

    TermsTitle4: '退款政策',
    REFUNDT1: '月租服務費用一經繳付，恕不接受退款。',

    isAgree: '我同意並接受條款及細則。',

    SuccessTitle: '預訂成功',
    SuccessNumber: '參考編號：',
    SuccessFee: '手續費用：',
    SuccessT1: '感謝您選用威信，您將收到確認電郵。',
    SuccessT2: '當您到達車場時，我們的車場職員將為您提供適切的服務。',
    SuccessRemark: '備註:',
    SuccessR1: '1.預訂服務將由預訂入場時間起一小時內有效。',
    SuccessR2: '2.手續費不設退款。',
    SuccessR3: '3.時租收費會於入場時開始計算。',
    SuccessR4: '4.客戶需遵從停車場的泊車及使用條款。',
    SuccessR5: '5.如有任何查詢，請發送電郵至',

    HKD: '港幣',
    HKD1: '正',

    ErrorMsg: '請同意並接受條款及細則。',

    sevenSuccess: '感謝您選用威信，您將收到一個確認短訊/電郵。',
  },
  BookingService: {
    isReserved: '固定車位',
    isNotReserved: '非固定車位',
  },
  PaymentRecords: {
    status: '狀況',
    vehicleRegistrationMark: '車輛',
    carPark: '停車場',
    paymentRefNo: '交易參考編號',
    paymentDate: '付款日期',
    paymentMethod: '付款方式',
    tempChange: '暫時更改車輛登記號碼',
    permChange: '永久更改車輛登記號碼',
    iMonthly: 'i-Monthly 預訂月租',
    renew: '續訂',
    '7-11': '7-11',
    cheque: ' 支票',
    changeCar: '更改車牌',
  },
  IPark: {
    addVehicle: '新增車輛',
    activate: '啟動',
    carType: '車輛類型 ',
    VRH: '車輛登記號碼 ',
    fillError: '請填寫以下所有資料。',
    add: '新增',
    select: '選擇',
    selectFrom: '從我的車輛中選擇',
    changeVer: '更改啟動方式',
    pleaceUseCredit: '請使用以下信用卡在任何',
    pleaceUseOctopus: '請使用以下八達通卡在任何',
    iParkSupport: '支援iPark的停車場',
    once: '進出一次以啟動服務',
    step2Title: '請輸入八達通卡背上的號碼以啟動感應式付款。',
    stepText: '請輸入於八達通背面的8位八達通號碼，括號除外',
    step2CardTitle: '請在彈出視窗驗證您的信用卡',
    step2CardText: '點擊此處如果彈出視窗沒有顯示',
    octopusError: '請輸入8位八達通號碼',
    secure: '安全付款',
    card: '信用卡號碼',
    expiration: '有效期限',
    cvv: '安全碼',
    authorize: '授權',
    cancel: '取消',
    name: '威信停車場',
    cardError: '信用卡號碼錯誤',
  },
  IParkVerifySteps: {
    title: '啟動感應式付款',
    step1: '選擇驗證方法',
    step2: '提供驗證資料',
    step3: '啟動指示',
    select: '選擇驗證方法',
    octopus: '八達通',
    creditCard: '信用卡',
    back: '上一步',
    next: '下一步',
    PPS: '繳費靈',
    FPS: '轉數快',
    '7-11': '於7-11便利店付款',
    cheque: '以支票付款',
  },
  PaymentLinkCart: {
    title: '付款',
    Step1: '確認資料',
    Step2: '付款',
    Step3: '完成',
    VisaText: '此付款方式將安全地被儲存作下次交易之用',
    error: '錯誤續訂日期',
    hrefError: '無效的付款連結',
    WILMemberReminder:
      '簡單一步免費登記，即可做WIL會員，每次月租都可賺分；更尊享額外2小時免費泊車及港幣$100加德士汽油優惠券！',
    regNow: '立即登記',
    skip: '跳過',
    showAgain: '不再顯示',
  },
  sevenPayment: {
    alertText1:
      '1. 此二維碼會在24小時後失效，如未能於24小時內付款，你須重新點擊手機短訊內的付款連結，以獲取新二維碼。\n\n2. 付款後請上載所有收據，然後再按「確認付款」。',
    alertText2: '2. 付款後請上載所有收據，成功上載後按「確認收據 」，然後再按「確認付款」。',
    text1: '7-11便利店付款',
    text2: '請向店員出示二維碼付款',
    text3: '(請在返回此頁時刷新)',
    text4: '預訂類別 : ',
    text5: '服務有效日期: ',
    text6: '指定車輛: ',
    text7: '請於付款後上載收據',
    text8: '上限: ',
    text9: '上載收據',
    text10: '返回主頁',
    text11: '停車場: ',
    errorMsg:
      '很抱歉！系統不能讀取您的收據，請重新上載您的收據。\n\n1.上載的影像必須清晰顯示收據金額、戶口號碼和付款日期。\n\n2.請在平坦的表面上拍攝收據。\n\n3.拍攝收據時請關閉閃光燈並確保光線充足。',
    failMsg: '系統無法辨識您的收據。如需協助，請與停車場的職員聯繫。',
    threeTimeError:
      '你已上載收據和進行OCR驗證辦識3次不成功。 \n 請聯繫我們的客服團隊，以作進一步協助',
    valid: '此二維碼只在24小時內有效',
    applicable: ' 月租適用',
    Renew: '續訂',
    complete: '完成付款',
    close: '關閉',
    remove: '移除',
    back: '返回主頁',
    progress: '付款進行中',
    no: '你的發票編號是 :',
    confirm: '付款一經確認，系統會在兩個工作天內發出短訊/電郵通知。',
    success: '成功付款',
    service: '服務: ',
    receipt: {
      title: '收據內容',
      billnumber: '帳戶號碼: ',
      amount: '收據金額: ',
      date: '收據日期: ',
      time: '收據時間: ',
      makesure: '請確保其收據資料正確及與付款頁面內容相符。',
      reupload: '重新上載',
      complete: '確認',
      passed: '成功通過OCR驗證',
    },
  },
  chequePayment: {
    alertText1:
      '1. 按「關閉」後，會顯示一個18位數字帳單戶口號碼。\n\n2. 預備劃線支票，收款人為「威信停車場管理(控股)有限公司」。  前往設有「入票易存票機」的匯豐銀行。\n\n3. 於「入票易」: 選擇 [繳付帳單] >商戶 [威信停車場 管理(控股)有限公司]>[01月租費用]。然後輸入支票金額及18位數字帳單戶口號碼。\n\n4. 插入支票並保留通知書。\n\n5. 上載收據，然後按「完成付款」。',
    payBy: '於匯豐銀行「入票易」以支票入賬',
    payable: '請確認支票抬頭為',
    name: '「威信停車場管理(控股)有限公司」',
    billAc: '輸入賬單戶口號碼：',
    billType: '賬單類別: ',
    billType1: '01 月租費用',
    bookingType: '預訂類別:',
  },
  fpsPayment: {
    alertText1:
      '1. 請用螢幕截圖儲存二維碼。\n\n2. 選擇「轉數快付款」，並登入您的銀行帳戶。\n\n3. 上載已儲存的二維碼後繼續付款。',
    payBy: '轉數快付款',
    useCap: '請用螢幕截圖儲存二維碼',
  },
  Search: {
    search: '搜尋關鍵字...',
    yourResult: '您的搜尋結果:',
    total: '您的搜尋找到: ',
    result: '個結果',
    carPark: '停車場',
    award: '獎項',
  },
  OTP: {
    validate: '驗證您的手提電話號碼',
    phone: '手提電話號碼',
    code: '驗證碼',
    press: '發送驗證碼 ({{seconds}})',
    send: '發送訊息',
    confirm: '確認',
    codeError: '請輸入認證碼',
    codeAlertError: '認證碼錯誤',
    unkonwError: '發生錯誤，請稍後再試',
    resend: '重新發送',
  },
  SkiDataMonthlyParkerRecord: {
    import: '確認月租泊車服務記錄',
    found: '請確認以下月租泊車服務記錄是否正確。如有需要，請致電28303845 與客戶服務聯絡。',
    confirm: '確認',
    wp: '威信停車場',
    remind: '如果您不想導入以上記錄，請使用其他電話號碼。',
    ppcard: 'Park泊Card:  ',
    registrationMark: '車輛登記號碼:  ',
    carPark: '停車場:  ',
    back: '返回',
  },
  AccountDeletion: {
    surveyTitle: '請告訴我們您為甚麼想刪除此帳戶。',
    DUPLICATED_ACCOUNT: '我已有重複的帳戶。',
    ANOTHER_ACCOUNT: '我想申請新的帳戶。',
    NO_CONTACTLESS: '我不再使用免觸式泊車或其他網上服務。',
    SELDOM_USE: '我甚少使用威信停車場。',
    PRIVACY_CONCERNS: '我有私隱的考慮。',
    MANY_NOTIFICATIONS: '我從威信停車場接收過多的電郵/ 短訊 / 推送訊息。',
    OTHER: '其他',
    remark: '請填寫原因',
    otherError: '請填寫原因',
  },
  ErrorCode: {
    CART_005: '揀選的車牌已是此停車場的登記月租車輛。請重新選擇。',
    CART_009: '未能提供服務\n您所選的月租服務已滿。',
  },
};
